// 请求失败后的统一拦截，以及ajax的基本设置
import axios from 'axios';
import qs from 'qs';
import Vue from 'vue';

function cleanRequest(req) {
  for (const i in req) {
    /* eslint guard-for-in: 0 */
    if (req[i] !== 0 && !req[i]) {
      delete req[i];
    }
  }
}

axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = null;
// axios.defaults.headers['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept, Connection, User-Agent, Cookie';
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.post['Content-Type'] = 'application/json';

let publicPath = {
  // dev: 'https://qa.knowbox.cn:8004',
  dev: 'https://beta-stuapi.knowbox.cn:9903',
  // dev: 'https://stuapi.knowbox.cn',
  // 之前存在部署完预览环境，接口调的是线上接口的问题；由于nginx配置指向的是production，XR改成了指向preview。
  // 注意：如果测试环境部署后不生效可以将test改为preview，下面真正的preview改成test；没问题就算啦。
  test: 'https://beta-stuapi.knowbox.cn:9903',
  preview: 'https://pre-stuapi.knowbox.cn',
  production: 'https://stuapi.knowbox.cn',
};

axios.defaults.baseURL = publicPath[process.env.VUE_APP_INTER] || '/';

Vue.prototype.$http = axios;
Vue.http = axios;

// axios.interceptors.request.use(
//   function (request) {
//     const params = request.params;
//     const body = request.data;
//     if (params) {
//       cleanRequest(params);
//     }
//     if (body) {
//       cleanRequest(body);
//       if (body.append) {
//       } else {
//         // 普通表单
//         request.data = qs.stringify(body);
//       }
//     }
//     return request;
//   },
//   function (error) {
//     return Promise.reject(error);
//   }
// );

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
export default axios;
